import {
  CarouselScrollDirection,
  isRtlElement,
  scrollElementHorizontalCircular,
} from './carousel-scroll.util';

/** Maps visible prev/next buttons to scroll direction for RTL tracks. */
export function resolveCarouselButtonDirection(
  button: CarouselScrollDirection,
  track: HTMLElement
): CarouselScrollDirection {
  if (!isRtlElement(track)) {
    return button;
  }

  return button === 'next' ? 'prev' : 'next';
}

export function scrollCarouselCircular(
  track: HTMLElement,
  button: CarouselScrollDirection,
  step: number
): void {
  scrollElementHorizontalCircular(track, resolveCarouselButtonDirection(button, track), step);
}
